/**
 * @providesModule NavigationRef
 */

import {createNavigationContainerRef} from '@react-navigation/native';

export const navigationRef = createNavigationContainerRef();
